import BaseModel from './BaseModel';
import FileModel from './FileModel';
import UserModel from './UserModel';

export default class FleetFuelLogModel extends BaseModel {
  init(data) {
    this.id = data.id || 0;
    this.vehicle = data.vehicle || null;
    this.date = data.date || '';
    this.odometer = data.odometer || 0;
    this.gallons = parseFloat(data.gallons) || 0;
    this.totalCost = data.total_cost == null ? null : parseFloat(data.total_cost);
    this.station = data.station || '';
    this.loggedBy = data.logged_by || data.created_by || null;
    if (this.loggedBy) {
      this.loggedBy = new UserModel(this.loggedBy);
    }
    this.attachments = (data.attachments || []).map(a => new FileModel(a));
    this.created = data.created ? new Date(data.created) : null;
  }

  get dateDate() {
    return this.stringToDate(this.date);
  }

  get pricePerGallon() {
    if (this.totalCost == null) return null;
    if (!this.gallons) return 0;
    return this.totalCost / this.gallons;
  }
}
